export const AcceptedImageMimes = "image/jpeg,image/png,image/heic";
export const AcceptedDocumentMimes = `application/pdf,${AcceptedImageMimes}`;
